import React, { useState } from "react";

interface Props {
    children: string;
}

const ReadMore: React.FC<Props> = ({ children }) => {
    const text = children;
    const [isReadMore, setIsReadMore] = useState(true);
    const toggleReadMore = () => {
        setIsReadMore(!isReadMore);
    };
    return (
        <p className="text-[#454551] text-[14px] font-light mt-2">
            {isReadMore && text.length > 70 ? text.slice(0, 70) : text}
            <span onClick={toggleReadMore} className="text-primary">
                {text.length > 70 ? isReadMore ? "... View More" : " View Less" : ""}
            </span>
        </p>
    );
};

export default React.memo(ReadMore)